import React from 'react';

class Box extends React.Component {
    render() {
        const style = {
            display: (this.props.visible === false) ? "none" : "block"
        };

        return (
            <div style={style}>
                <div className={'box box-' + this.props.boxStyle}>
                    {this.props.title &&
                        <div className="box-header with-border">
                            <h3 className="box-title">
                                {this.props.title}
                            </h3>
                            {this.props.action}
                        </div>}
                    <div className="box-body">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default Box;



// WEBPACK FOOTER //
// ./src/fw/components/box/Box.js